import ReportIndex from '../components/reports/Index.vue';
import PendingPayments from '../components/reports/PendingPayments.vue';



export default [
  {
    path: '/reports',
    name: 'ReportsIndex',
    component: ReportIndex,
    meta: {
      requiresAuth: true,
      permissions: {
        Reports: ['*']
      }
    }
  },
  {
    path: '/reports/pending-payments',
    name: 'PendingPayments',
    component: PendingPayments,
    meta: {
      requiresAuth: true,
      permissions: {
        Reports: ['Pending Payments']
      }
    }
  },
 
]



// WEBPACK FOOTER //
// ./src/router/ReportRoutes.js